import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

/** Liest das Token aus einem Link `…#token=…` (Fragment: geht nie an den Server oder in dessen Protokolle). */
export function tokenFromHash(hash: string): string | null {
  const token = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash).get('token');
  return token === null || token === '' ? null : token;
}

/**
 * Liefert das Token des Links und entfernt es danach aus der Adresszeile (und damit aus dem Verlauf,
 * soweit es die Seite betrifft). Der Wert bleibt in der Seite erhalten, solange sie geöffnet ist.
 */
export function useFragmentToken(): string | null {
  const { hash } = useLocation();
  const [token] = useState(() => tokenFromHash(hash));
  useEffect(() => {
    if (window.location.hash !== '') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }, []);
  return token;
}
